import React, { Component } from 'react';
import { Route, withRouter } from "react-router-dom";
import posed, { PoseGroup } from 'react-pose';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectReducer from './utils/injectReducer';

import {
  makeSelectLoginFormState,
  makeSelectError,
  makeSelectSending,
  makeSelectLoggedIn,
  makeSelectSessionToken,
  makeSelectNotifications,
  makeSelectProjects,
  makeSelectCategories
} from './selectors';
import reducer from './reducer';
import saga from './saga';

import {
  loadStartup, checkToken, loginRequest, logout, oAuthLoginRequest, registerRequest,
} from './actions';
import injectSaga from './utils/injectSaga';

import ResponsiveContainer from './components/ResponsiveContainer';

import HomePage from './components/HomePage.js';
import EditorPage from './components/EditorPage.js';
import AudiobooksPage from './components/AudiobooksPage.js';
import GamePage from './containers/GamePage/Loadable';
import AppPage from './components/AppPage.js';
import TeamPage from './components/TeamPage.js';
import Imprint from './components/Imprint/Imprint';
import ImprintEN from './components/Imprint/ImprintEN';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import PrivacyPolicyEN from './components/PrivacyPolicy/PrivacyPolicyEN';
import TOS from './components/TOS/TOS';
import TOSEN from './components/TOS/TOSEN';
import UserPage from './components/UserPage';
import UserListPage from './components/UserListPage';
import CategoryPage from './components/CategoryPage';
import CategoryListPage from './components/CategoryListPage';
import GutscheinPage from './components/GutscheinPage';
import COS from './components/TOS/COS';
import CrowdfundingPage from './components/CrowdfundingPage';
import FAQPage from './components/FAQPage';
import B2BPage from './components/B2BPage';
import PressPage from './components/PressPage';
import CareerPage from './components/CareerPage';


// pose the router
const RoutesContainer = posed.div({
  enter: {
    delay: 150,
    beforeChildren: true,
    staggerChildren: 50
  },
  exit: { staggerChildren: 20, staggerDirection: -1 }
});

class App extends Component {

  componentDidMount() {
    //this.props.startup();
  }

  componentWillMount() {
    this.props.validateToken();
  }

  render() {    
    return (
      <PoseGroup>
        <RoutesContainer key={window.location}>
        <ResponsiveContainer>
          <Route exact path="/" component={HomePage} />
          <Route path="/editor" component={EditorPage} />
          {/*<Route path="/books" component={AudiobooksPage} />*/}
          
          <Route
            exact
            path="/play/:id"
            render={(props) => {
            return (<GamePage />)}}
          />
          <Route
            exact
            path="/page/:id"
            render={(props) => {
            return (<HomePage />)}}
          />
          <Route exact path="/user/:id" component={UserPage} />
          <Route exact path="/user" component={UserListPage} />
          <Route exact path="/category/:id" component={CategoryPage} />
          <Route exact path="/category" component={CategoryListPage} />
          {/*<Route path="/app" component={AppPage} />*/}
          <Route path='/gutschein' component={GutscheinPage} />
          <Route path='/b2b' component={B2BPage} />
          <Route path='/press' component={PressPage} />
          <Route path='/career' component={CareerPage} />
          <Route path='/team' component={TeamPage} />
          <Route path='/faq' component={FAQPage} />
          <Route path="/tos" component={TOS} />
          <Route path="/cos" component={COS} />
          <Route path="/imprint" component={Imprint} />
          <Route path="/privacypolicy" component={PrivacyPolicy} />
          {
            /*
              <Route path="/en/tos" component={TOSEN} />
              <Route path="/en/imprint" component={ImprintEN} />
              <Route path="/en/privacypolicy" component={PrivacyPolicyEN} />
            */
          }
          
        </ResponsiveContainer>
          </RoutesContainer>
        </PoseGroup>
    );
  }
}

// container actions
export function mapDispatchToProps(dispatch) {
  return {
    startup: () => dispatch(loadStartup()),
    onLoginSubmit: (username, password) => { dispatch(loginRequest({ username, password })); },
    onRegisterSubmit: (data) => { dispatch(registerRequest(data)); },
    onFacebookLogin: () => { dispatch(oAuthLoginRequest('facebook')); },
    onTwitterLogin: () => { dispatch(oAuthLoginRequest('twitter')); },
    onGoogleLogin: () => { dispatch(oAuthLoginRequest('google')); },
    onLogoutSubmit: () => { dispatch(logout()); },
    validateToken: () => { dispatch(checkToken()); },
  };
}
// container store props
const mapStateToProps = createStructuredSelector({
  projects: makeSelectProjects(),
  categories: makeSelectCategories(),
  formstate: makeSelectLoginFormState(),
  error: makeSelectError(),
  sending: makeSelectSending(),
  loggedin: makeSelectLoggedIn(),
  sessionToken: makeSelectSessionToken(),
  notifications: makeSelectNotifications(),
});

// container export
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'global', reducer });
const withSaga = injectSaga({ key: 'auth', saga });
export default compose(
  withReducer,
  withSaga,
  withRouter,
  withConnect,
)(App);



// WEBPACK FOOTER //
// ./src/App.js